import { twMerge } from 'tailwind-merge';

type PackageImageProps = {
  src: string;
  alt: string;
  totalShares: number;
  className?: string;
  wrapperClassName?: string;
  countClassName?: string;
  countSubtitleClassName?: string;
};

export const PackageImage = ({
  src,
  alt,
  totalShares,
  className,
  wrapperClassName,
  countClassName,
  countSubtitleClassName,
}: PackageImageProps) => {
  return (
    <div className={twMerge('tw-relative', wrapperClassName)}>
      <img src={src} alt={alt} className={className || 'tw-mx-auto tw-block tw-h-auto tw-w-full tw-max-w-full'} />
      <div className="tw-absolute tw-bottom-[10%] tw-left-0 tw-right-0 tw-flex tw-justify-center">
        <div className="tw-flex tw-flex-col tw-items-center">
          <div className={twMerge('tw-font-bold tw-leading-none tw-text-white', countClassName)}>{totalShares}</div>
          <div className={twMerge('tw-uppercase tw-leading-none tw-text-white', countSubtitleClassName)}>
            {totalShares > 1 ? 'fractions' : 'fraction'}
          </div>
        </div>
      </div>
    </div>
  );
};
